import React from 'react';

interface FlagProps {
  size?: number;
  className?: string;
}

// Bandeiras simplificadas (proporção 3:2), usadas no seletor de idioma — SVG em vez
// de emoji porque bandeiras emoji não renderizam em várias fontes do Windows (caem
// para o texto "BR"/"ES").
export const FlagBR: React.FC<FlagProps> = ({ size = 20, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 30 30"
    className={className}
    role="img"
    aria-hidden="true"
  >
    <clipPath id="flagbr-circle"><circle cx="15" cy="15" r="15" /></clipPath>
    <g clipPath="url(#flagbr-circle)">
      <rect width="30" height="30" fill="#009C3B" />
      <polygon points="15,4 27,15 15,26 3,15" fill="#FFDF00" />
      <circle cx="15" cy="15" r="6.2" fill="#002776" />
      <path d="M9.2,13.6 a6.2,6.2 0 0 0 11.6,0" fill="none" stroke="#fff" strokeWidth="0.9" />
    </g>
  </svg>
);

export const FlagES: React.FC<FlagProps> = ({ size = 20, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 30 30"
    className={className}
    role="img"
    aria-hidden="true"
  >
    <clipPath id="flages-circle"><circle cx="15" cy="15" r="15" /></clipPath>
    <g clipPath="url(#flages-circle)">
      <rect width="30" height="30" fill="#AA151B" />
      <rect y="7.5" width="30" height="15" fill="#F1BF00" />
    </g>
  </svg>
);
